exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content[data-v-51301abb] {\n  padding: 5px 15px;\n}\n", ""]);

// exports
